export default "__VITE_ASSET__CkQ4MqG4__"